//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Additions',
  props: {
    title: {
      type: String,
      default: () => 'E-mail'
    },
    value: {
      type: String,
      default: () => ''
    },
    divider: {
      type: Boolean,
      default: () => false
    }
  }
}
